// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-btn-footer-btn-gap-e2c52{height:102px}.footer-btn-footer-btn-212f8{align-items:center;background-color:var(--GRAY_11);bottom:0;display:flex;height:82px;left:0;padding-left:16px;position:fixed;width:100%}.footer-btn-footer-btn-212f8 .ant-btn:first-child{margin-left:calc(50vw - 605px)}.footer-btn-footer-btn-212f8 .ant-btn:not(:first-child){margin-left:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer-btn-gap": "footer-btn-footer-btn-gap-e2c52",
	"footerBtnGap": "footer-btn-footer-btn-gap-e2c52",
	"footer-btn": "footer-btn-footer-btn-212f8",
	"footerBtn": "footer-btn-footer-btn-212f8"
};
export default ___CSS_LOADER_EXPORT___;
